import React from 'react';

import LocationIndicator from "components/sub-components/LocationIndicator/LocationIndicator";
import PageContainerComponent from "../../../../../../components/common/page-container-component/PageContainerComponent";
import styles from "./PaymentPage.module.css";
import FloorPlateNavOptions from "components/common/floor-plate-nav-options/FloorPlateNavOptions";
import { Box, Divider } from "@chakra-ui/react";
function PaymentPage() {
  const labels_Values = [
    { label: 'Type', value: 'Garden' },
    { label: 'View', value: 'Street' },
    { label: 'Area', value: '139' },
    { label: 'Garden', value: '42' },
    { label: 'Total Area', value: '181' },
    { label: 'Cash Price + Parking + Storage', value: '2,691,028' },
    { label: 'Maintenance', value: '384,817' },
    { label: 'Club House', value: '125,000' },
    { label: 'Installment 7 years', value: '3,848,171' },
    { label: 'Installment 15% Deposit', value: '577,226' },
    { label: 'Installment 7 years', value: '467,278' },
    { label: 'Installment Parking', value: '150,000' },
    { label: 'Installment Warehouse', value: 'N/A' },
    { label: 'Status', value: 'Available' },
    { label: 'Finishing', value: 'Core & Shell' },
    { label: 'Delivery', value: 'Ready To Go' },
  ];
  return (
    <PageContainerComponent>
      <LocationIndicator text="Zone 5 - Type D" fontSize={60} />
      <div className={styles.paymentContainer}>
        {labels_Values.map((item, index) => (
          <>
            <Box className={styles.paymentColumn} key={index}>
              <Box
                as="p"
                className={styles.paymentColumnLabel}
                fontSize={{
                  tablet7: "1.6rem",
                  tablet16: "3rem",
                }}
              >
                {item.label}
              </Box>
              <Box
                as="p"
                className={styles.paymentColumnValue}
                fontSize={{
                  tablet7: "1.6rem",
                  tablet16: "3rem",
                }}
              >
                {item.value}
              </Box>
            </Box>
            <Divider color="brown" />
          </>
        ))}
      </div>
      <FloorPlateNavOptions isPaymentPage />
    </PageContainerComponent>
  );
}

export default PaymentPage;
